import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-with-line",
  "use": "icon-arrow-with-line-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-arrow-with-line\"><path d=\"M2 7.875a1.125 1.125 0 0 0 0 2.25v-2.25Zm16.796 1.92c.439-.439.439-1.151 0-1.59l-7.16-7.16a1.125 1.125 0 0 0-1.591 1.591L16.409 9l-6.364 6.364a1.125 1.125 0 0 0 1.591 1.591l7.16-7.16ZM2 10.125h16v-2.25H2v2.25Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol